module.exports = __webpack_public_path__ + "img/Asset7.196cbf32.png";